import cn from 'classnames'
import KeyboardNavigator from 'components/KeyboardNavigator'

import styles from './styles.css'

export default function SearchFor({
  onSubmit,
  onChangeToSubmit,
  searchQuery,
  className,
}) {
  return (
    <KeyboardNavigator.Item
      active
      activeClassName={styles.SearchSuggestions_activeSubmitSuggestion}
      onSelect={onSubmit}
      onActivate={onChangeToSubmit}
      className={className}
    >
      <div
        className={cn(
          styles.SearchSuggestions_suggestion,
          styles.SearchSuggestions_submitSuggestion,
          styles.SearchSuggestions_ready
        )}
      >
        <div
          className={cn(styles.hint, styles.SearchSuggestions_suggestionHint)}
        >
          Show all results for
        </div>
        <div
          className={cn(
            styles.suggestion,
            styles.SearchSuggestions_suggestionQuery,
            'grui truncate'
          )}
        >
          {searchQuery}
        </div>
      </div>
    </KeyboardNavigator.Item>
  )
}
